export default "__VITE_ASSET__CpeaOg1W__"